import { Box } from '@mui/material';
import styled from 'styled-components';

export const ListActionWrapper = styled.div`
  margin-top: 20px;
  width: 100%;
`;

export const ListActionContainer = styled.div`
  position: relative;
  width: max-content;
  padding-left: 4px;
  padding-right: 4px;
  padding-top: 8px;
  margin-left: auto;
  border-top: 2px solid ${({ theme }) => theme.palette.primary.main};
  border-left: 2px solid ${({ theme }) => theme.palette.primary.main};
  border-right: 2px solid ${({ theme }) => theme.palette.primary.main};
  border-radius: ${({ theme }) => `${theme.shape.borderRadius}px ${theme.shape.borderRadius}px 0 0`};
  margin-bottom: -2px;
  background-color: ${({ theme }) => theme.palette.primary.light};
  z-index: 5;
`;

export const ListWrapper = styled(Box)<{ corner?: boolean }>`
  display: flex;
  flex-direction: column;
  border: 2px solid ${({ theme }) => theme.palette.primary.main};
  border-radius: ${(p) =>
    p.corner
      ? `${p.theme.shape.borderRadius}px 0 ${p.theme.shape.borderRadius}px ${p.theme.shape.borderRadius}px`
      : p.theme.shape.borderRadius + 'px'};
  overflow: hidden;
  max-height: calc(100vh - 80px);
  z-index: 4;
`;
export const ListHeader = styled.div<{ gridTemplateColumns: string }>`
  padding: 5px;
  display: grid;
  grid-template-columns: ${(p) => p.gridTemplateColumns};
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.main};
  align-items: center;
  background-color: ${({ theme }) => theme.palette.primary.light};
`;

export const ListFooter = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 5px;
  height: 35px;
  align-items: center;
  background-color: ${({ theme }) => theme.palette.primary.light};
`;

export const ItemWrapper = styled.div<{ gridTemplateColumns: string; selected?: boolean }>`
  padding: 5px;
  display: grid;
  grid-template-columns: ${(p) => p.gridTemplateColumns};
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.palette.primary.main};
  background-color: ${({ theme, selected }) => (selected ? theme.palette.primary['100'] : '')};
  :hover {
    background-color: ${({ theme, selected }) =>
      selected ? theme.palette.primary.light : theme.palette.primary['100']};
    cursor: pointer;
  }
`;

export const ListContainer = styled.div`
  background-color: ${({ theme }) => theme.palette.common.white};
  overflow-y: auto;
  max-height: calc(100vh - 150px);
`;
